module.exports = __webpack_public_path__ + "img/warning.62510cdb.svg";